export default "__VITE_ASSET__9764a9fb__"